export const EMPTY_CHARACTER = '\u00a0';
export const MARITAL_STATUS_MARRIED = 'Married';
export const MARITAL_STATUS_DEFACTO = 'DeFacto';
export const FORM_NAME = 'applicantsAndGuarantorsForm';
